import React from "react";
import i18n, { getI18NMessage } from "./../../../i18n/I18N";
import LoginCnt from "./../../login/components/LoginCnt";
import UserNotRegistered from "./../../login/components/UserNotRegistered";
import EmailVerification from "./../../login/components/EmailVerification";
import loadingImg from "./../../../../assets/images/loaders/loading.svg";
import Permission from "../../oauth/components/Permission";
import faviconImg from "./../../../../assets/images/favicons/favicon.svg";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.onURLHashChange = this.onURLHashChange.bind(this);

    window.addEventListener("hashchange", this.onURLHashChange);
  }

  componentDidMount() {
    i18n.changeLanguage(navigator.language || navigator.userLanguage);
    this.props.initAppComp();
    this.onURLHashChange();

    const favIconLink = document.createElement("link");

    favIconLink.setAttribute("rel", "icon");
    favIconLink.setAttribute("type", "image/x-icon");
    favIconLink.setAttribute("href", `${window.appCdnPath || ""}${faviconImg}`);

    document.head.appendChild(favIconLink);
  }

  render() {
    if (!this.props.appData || !this.props.appData.loaded) {
      return false;
    }

    const { showLoader, urlHashData } = this.props.appData;

    const isPermissionPage = window.location.href.includes("/permissions");
    const showLoginCnt =
      urlHashData !== "#notregistered" &&
      urlHashData !== "#emailnotverified" &&
      !isPermissionPage;

    return (
      <React.Fragment>
        {urlHashData === "#notregistered" && <UserNotRegistered />}
        {urlHashData === "#emailnotverified" && <EmailVerification />}
        {showLoginCnt && (
          <LoginCnt store={this.props.store} appUrlHash={urlHashData} />
        )}
        {isPermissionPage && <Permission />}
        {showLoader && (
          <div className="app_mask">
            <img
              className="loader"
              src={loadingImg}
              alt={getI18NMessage("loadmessage")}
              width="100%"
              height="100%"
            />
          </div>
        )}
      </React.Fragment>
    );
  }

  onURLHashChange() {
    this.props.setURLHashData(window.location.hash);
  }

  componentWillUnmount() {
    window.removeEventListener("hashchange", this.onURLHashChange);
  }
}

export default App;
